import React, { useState, useEffect } from 'react';
import { Button } from 'reactstrap';

//Constants
import { actionsTable } from '../../../../constants/MaterialTable';

//Components
import TabelaListagem from '../../../../components/TabelaListagem/TabelaListagem';
import TipoDeRequerimentoStepper from './Components/TipoDeRequerimentoStepper';

//Api
import tipoRequerimento_api from '../../../../api/tipoRequerimento_api';

//context
import { useAuth } from '../../../../context/auth';

//Helpers
import { getSessionCookie } from '../../../../helpers/cookies';
import { showMessage } from '../../../../helpers/message';

export default function TiposDeRequerimentos({ permissoes }) {
    const { setLoading } = useAuth();

    const session = getSessionCookie();

    //Estado de controle da lista de tipo de requerimento
    const [tiposRequerimentos, setTiposRequerimentos] = useState();

    //Estado de controle de exibição da tela de cadastro
    const [cadastro, setCadastro] = useState(false);

    //Estado de controle para edição de tipo de requerimento
    const [idTipoRequerimento, setIdTipoRequerimento] = useState(null);

    //Função de configuração de visualização do tipo de requerimento
    const visualizar = (tipoRequerimento) => {
        setIdTipoRequerimento(tipoRequerimento.id);
    }
    //Ações que a tabela terá
    const actions = [actionsTable.visualizar(visualizar)];

    //Cabeçalhos que a tabela terá
    const headers = [
        { value: "Identificação", objectValue: "identificacao", align: "left" },
        { value: "Status", objectValue: "status", align: "left" }
    ]
    const loadTiposRequerimento = () => {
        setLoading(true);
        tipoRequerimento_api.getList().then(response => {
            setTiposRequerimentos(response.data);
        }).catch(ex => {
            showMessage("Erro", ex.message, "error", null);
        }).finally(f => {
            setLoading(false);
        });
    }
    useEffect(() => {
        loadTiposRequerimento();
    }, []);

    if (cadastro || idTipoRequerimento)
        return <TipoDeRequerimentoStepper
            btnVoltar={() => {
                setCadastro(false);
                loadTiposRequerimento();
                setIdTipoRequerimento(null);
            }}
            id={idTipoRequerimento}
            editavel={session.perfil == "Master"}
        />

    return (
        <>
            <div className='d-flex align-items-center justify-content-between mb-4'>
                <h4 className='text-secondary m-0'>Tipos de requerimentos</h4>
                {session.perfil == "Master" &&
                    <Button color='success' onClick={() => { setCadastro(true) }}>+ Cadastrar</Button>
                }
            </div >
            <TabelaListagem
                actions={actions}
                title={"Lista de tipos de requerimentos"}
                options={{ print: false, search: true, pagination: true }}
                headers={headers}
                items={tiposRequerimentos}
            />
        </>
    )
}